import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

export type CoinPurchaseAnimationRef = {
  show: () => Promise<void>;
};

const CoinPurchaseAnimation = forwardRef<CoinPurchaseAnimationRef>((_, ref) => {
  const [isShown, setShown] = useState(false);
  const coinRef = useRef<HTMLImageElement>(null);

  const show = async () => {
    if (coinRef.current) {
      setShown(true);

      await new Promise((resolve) => setTimeout(resolve, 1000));
      coinRef.current.style.display = 'flex';

      await new Promise((resolve) => setTimeout(resolve, 3000));

      setShown(false);

      await new Promise((resolve) => setTimeout(resolve, 300));
    }
  };
  useImperativeHandle(ref, () => ({ show }));

  return (
    <div
      className="pointer-events-none fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center transition-all duration-300"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.55)', opacity: isShown ? 1 : 0 }}
    >
      <img ref={coinRef} className="coin-animation-jump mt-auto h-[30vw] w-[30vw] object-contain" alt="" src="/imgweb/main/neo_coin.png" />
    </div>
  );
});

export default CoinPurchaseAnimation;
